class LoadingController {

}
LoadingController.$inject = [];
export default LoadingController;